import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"



interface IButtonProps {
	size?: keyof typeof sizeNames;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    size: { type: null, required: false }
  },
  setup(__props: any) {

const props = __props as {
	size?: keyof typeof sizeNames;
}
_useCssVars(_ctx => ({
  "93ccb15c": (sizeNames[_unref(size)].padding),
  "b99d90a6": (sizeNames[_unref(size)].textSize)
}))

const sizeNames = {
	large: {
		padding: '1rem 2rem',
		textSize: '1.2rem',
	},
	normal: {
		padding: '0.5rem 1rem',
		textSize: '1rem',
	},
	small: {
		padding: '0.25rem 0.5rem',
		textSize: '0.75rem',
	},
};



const size = props.size ?? 'large';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", null, [
    _createElementVNode("span", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})